var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "text-center" },
    [
      _c(
        "v-row",
        { attrs: { justify: "center", dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                { staticClass: "elevation-0" },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: "primaryMedium", large: "" } },
                        [_vm._v("mdi-text-box-multiple-outline")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-h6 font-weight-bold mt-3" },
                        [
                          _vm._v(
                            "\n                        No titles here yet\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "grey--text text--darken-1 mt-2 fs-16" },
                        [
                          _vm._v(
                            "\n                        View, subscribe or favorite titles to see them here\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mt-3",
                          attrs: {
                            color: "primary",
                            depressed: "",
                            href: _vm.getRoute("codes"),
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Browse All Codes\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }